import $ from 'jquery';

Drupal.behaviors.gutfeelingDetectScrol = {
  attach: function (context) {
    $(window).scroll(function() {
      const currentScrollPostition = $(window).scrollTop();
      if(currentScrollPostition > 0) {
        $('html').addClass('is-scrolling');
      } else {
        $('html').removeClass('is-scrolling');
      }
    });
  }
};